import { render, staticRenderFns } from "./DemographyCountriesGrid.vue?vue&type=template&id=4996cba2&"
import script from "./DemographyCountriesGrid.vue?vue&type=script&lang=js&"
export * from "./DemographyCountriesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports